import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IAttachFileItemState, IBusinessState, IHom0101PState } from '../../models/hom/hom0101p_model';
  
const initialState: IHom0101PState = {
    fileList        : [],
    attachFileItems : [],
    businessItem    : {},
}

export const hom0101p_Slice = createSlice({
    name: "hom0101p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setBusinessItem: (state, action:PayloadAction<IBusinessState>) => {
            state.businessItem = action.payload;
        },
        setFileList: (state, action:PayloadAction<any[]>) => {
            state.fileList = action.payload;
        },
        setAttachFileItems: (state, action:PayloadAction<IAttachFileItemState[]>) => {
            state.attachFileItems = action.payload;
        },
    },
});

export default hom0101p_Slice.reducer;
export const Hom0101pAction  = hom0101p_Slice.actions;
export const Hom0101pReducer = hom0101p_Slice.reducer;